import React from "react";
import styles from "../centromedicodonavitta_/servicos_centromedicodonavitta_.module.scss";
import {
    Stethoscope,
    Baby,
    Scissors,
    Zap,
    Heart,
    Apple,
    Activity,
    ArrowLeft,
} from "lucide-react";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import { Link } from "react-router-dom";

const whatsappLink = (servico: string) =>
    `https://wa.me/5517981360002?text=Olá! Vim pelo seu cartão digital e gostaria de saber mais sobre ${encodeURIComponent(
        servico
    )} na Dona Vitta`;

const Servicos_centromedicodonavitta_: React.FC = () => {
    return (
        <div className={styles.servicos_centromedicodonavitta_}>
            {/* Header */}
            <div className={styles.header}>
                <Link to="/centromedicodonavitta_" className={styles.backButton}>
                    <ArrowLeft />
                </Link>
                <h1>Nossos Serviços</h1>
            </div>

            {/* Serviços */}
            <div className={styles.services}>
                <div className={styles.card}>
                    <Stethoscope className={styles.icon} />
                    <h3>Ginecologia Geral</h3>
                    <p>Cuidado completo em todas as fases da vida feminina.</p>
                    <a href={whatsappLink("Ginecologia Geral")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Heart className={styles.icon} />
                    <h3>Climatério</h3>
                    <a href={whatsappLink("Climatério")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Zap className={styles.icon} />
                    <h3>Laser em Ginecologia</h3>
                    <a href={whatsappLink("Laser em Ginecologia")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Scissors className={styles.icon} />
                    <h3>Cirurgias Íntimas</h3>
                    <p>Procedimentos minimamente invasivos.</p>
                    <a href={whatsappLink("Cirurgia Íntima")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Activity className={styles.icon} />
                    <h3>Implanon, DIU</h3>
                    <a href={whatsappLink("Implanon, DIU")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Baby className={styles.icon} />
                    <h3>Pré-natal</h3>
                    <a href={whatsappLink("Pré-natal")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Baby className={styles.icon} />
                    <h3>Partos Respeitosos</h3>
                    <a href={whatsappLink("Partos Respeitosos")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Apple className={styles.icon} />
                    <h3>Nutrição</h3>
                    <p>
                        Nutricionista, especialista em nutrição funcional, com foco em saúde da
                        mulher, emagrecimento e obstetrícia.
                    </p>
                    <a href={whatsappLink("Nutrição")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Activity className={styles.icon} />
                    <h3>Fisioterapia em Saúde da Mulher</h3>
                    <p>
                        Da prevenção ao tratamento nas áreas de obstetrícia (gestação, parto e
                        pós-parto), uroginecologia, disfunção sexual e coloproctologia.
                    </p>
                    <a href={whatsappLink("Fisioterapia em Saúde da Mulher")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <p className={styles.footerTitle}>
                    Dona Vitta • Centro Médico da Mulher
                </p>
                <p className={styles.footerSubtitle}>
                    Seja Dona • Seja Vitta
                </p>

                <div className={styles.footerLinks}>
                    <a
                        href="https://www.instagram.com/centromedicodonavitta_?igsh=Y2t6Z2hseWVpZDQ1"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <InstagramIcon color="#456345" height="28" />
                    </a>
                    <a
                        href="https://maps.app.goo.gl/i5ygw1tv3QZEUeq88"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <MapsIcon color="#456345" height="36" />
                    </a>
                </div>
            </div>

            {/* Botão WhatsApp flutuante */}
            <a
                href="https://wa.me/5517981360002?text=Olá! Vim pelo seu cartão digital e gostaria de agendar uma consulta na Dona Vitta."
                className={styles.whatsappFloat}
                target="_blank"
                rel="noopener noreferrer"
            >
                <WhatsappIcon color="#fff" />
            </a>
        </div>
    );
};

export default Servicos_centromedicodonavitta_;
